module.exports = __webpack_public_path__ + "static/x56-314b56163a999ff992e405be01278649.png";